import React from 'react';
import {
  paymentType as PaymentTypes,
  paymentMethod as PaymentMethods,
  lookupsJson,
  policyType as PolicyTypes
} from '@ourbranch/lookups';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';

import { useStore } from 'core/store';
import { FormField } from 'core/components/form';
import { LabelTooltip } from 'core/components/label-tooltip';
import usePaymentFrequencyOptions from '../hooks/use-payment-frequency-options';

const paymentMethodOptionsMap = {
  [PolicyTypes.Auto]: lookupsJson.autoPaymentMethod,
  [PolicyTypes.Home]: lookupsJson.homeownersPaymentMethod,
  [PolicyTypes.Condo]: lookupsJson.condoPaymentMethod,
  [PolicyTypes.Farm]: lookupsJson.farmPaymentMethod
};

const RenewalPaymentOptions = () => {
  const {
    account: {
      policies: { policy: policyStore }
    }
  } = useStore();
  const { policy } = policyStore;
  const { values, setFieldValue } = useFormikContext();

  const isMortgage = values.renewalPaymentMethod === PaymentMethods.Escrow;
  const isPayToOther = values.paymentMethod === PaymentMethods.BillToOther;
  const isDirectPayment = values.paymentMethod === PaymentMethods.Direct;

  const { frequencyOptions, isDisabled, tooltip } = usePaymentFrequencyOptions(
    policy.renewalPaymentType,
    policy.policyType,
    policy.state
  );

  const filteredFrequencyOptions = frequencyOptions?.filter((opt) => {
    if (isMortgage) {
      return opt.id === PaymentTypes.Escrow;
    }
    if (isPayToOther) {
      return opt.id === PaymentTypes.OneTime;
    }
    if (isDirectPayment) {
      return ![PaymentTypes.Escrow, PaymentTypes.Monthly].includes(opt.id);
    }
    return true;
  });

  return (
    <>
      <FormField
        name="renewalPaymentMethod"
        type="select"
        label="Renewal Payment Method"
        mode="dark"
        xs={6}
        options={paymentMethodOptionsMap[policy.policyType]}
        permissions={{ isLicensedAction: false }}
        fast={false}
        onChange={(val) => {
          if (val === PaymentMethods.Escrow) {
            setFieldValue('renewalPaymentType', PaymentTypes.Escrow);
          } else {
            // ach or credit card
            setFieldValue(
              'renewalPaymentType',
              values.renewalPaymentType === PaymentTypes.Escrow ? PaymentTypes.OneTime : values.renewalPaymentType
            );
          }
        }}
      />
      {tooltip && (
        <Grid item xs={6}>
          <LabelTooltip
            label="Renewal Payment Frequency"
            tooltip={{
              label: 'More Info',
              onHoverText: tooltip
            }}
          >
            <FormField
              name="renewalPaymentType"
              type="select"
              disabled={isMortgage || isPayToOther || isDisabled}
              options={filteredFrequencyOptions}
              mode="dark"
              sions={{ isLicensedAction: false }}
              fast={false}
            />
          </LabelTooltip>
        </Grid>
      )}
      {!tooltip && (
        <FormField
          name="renewalPaymentType"
          type="select"
          label="Renewal Payment Frequency"
          mode="dark"
          xs={6}
          disabled={isMortgage || isPayToOther || isDisabled}
          options={filteredFrequencyOptions}
          permissions={{ isLicensedAction: false }}
          fast={false}
        />
      )}
    </>
  );
};

export default observer(RenewalPaymentOptions);
